module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("jgOrj"))).then(() => module.bundle.root('hEqeo'));